module.exports = __webpack_public_path__ + "img/火焰检测.aaedf27c.png";